// Dependencies
import { FC, useState } from "react";

// Components
import IconPicker from "../IconPicker";
import { theme } from "~/components/Common";
import { If } from "jsx-control-statements";

// types
import { DefaultCategory } from "~/enums";

// Styles
import {
  StyledWrapper,
  StyledImageIcon,
  StyledIconButton,
} from "./IconInput.styled";

interface IconInputProps {
  onChange: Function;
  name: string;
  id: string;
  value: string;
}

const IconInput: FC<IconInputProps> = ({ onChange, name, id, value }) => {
  const [hover, setHover] = useState<boolean>(false);
  const [openPicker, setOpenPicker] = useState<boolean>(false);

  const handleHover = () => {
    setHover(true);
  };

  const handleLeave = () => {
    setHover(false);
  };

  const handleOpenIconPicker = () => {
    setOpenPicker(true);
  };

  const handleCloseIconPicker = () => {
    setOpenPicker(false);
    setHover(false);
  };

  const handleChangeIcon = (event: { target: { value: string } }) => {
    onChange({
      target: { value: event.target.value, id, name },
    });
    handleCloseIconPicker();
  };

  return (
    <StyledWrapper
      onMouseOver={handleHover}
      onMouseLeave={handleLeave}
      style={
        hover
          ? {
              border: `1px dashed ${theme.palette.primary.main}`,
            }
          : {
              backgroundImage: `url(${DefaultCategory[value].icon})`,
            }
      }
    >
      <If condition={hover}>
        <StyledIconButton onClick={handleOpenIconPicker}>
          <StyledImageIcon />
        </StyledIconButton>
      </If>
      <If condition={openPicker}>
        <IconPicker
          onSelect={handleChangeIcon}
          onClose={handleCloseIconPicker}
        />
      </If>
    </StyledWrapper>
  );
};

export default IconInput;
